import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/role-ex";

export const pagingRoleEx = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getRoleExById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdate = role => axios.post(API_PATH + '/save-or-update', role);

export const deleteRoleEx = id => axios.delete(API_PATH + '/mark-delete/' + id);